import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import './styles/main.scss'
import './styles/colors.scss'
import './styles/text.scss'
import './styles/components.scss'
import './plugins/components';

declare const window: any;

Vue.config.productionTip = false

window.app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
